import { render, staticRenderFns } from "./premiumTemplateModel.vue?vue&type=template&id=65bfeae6&scoped=true"
import script from "./premiumTemplateModel.vue?vue&type=script&lang=js"
export * from "./premiumTemplateModel.vue?vue&type=script&lang=js"
import style0 from "./premiumTemplateModel.vue?vue&type=style&index=0&id=65bfeae6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bfeae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65bfeae6')) {
      api.createRecord('65bfeae6', component.options)
    } else {
      api.reload('65bfeae6', component.options)
    }
    module.hot.accept("./premiumTemplateModel.vue?vue&type=template&id=65bfeae6&scoped=true", function () {
      api.rerender('65bfeae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/infoFrom/premiumTemplateModel.vue"
export default component.exports